module.exports = {"331004001":"路南街道","331004002":"路桥街道","331004003":"路北街道","331004004":"螺洋街道","331004005":"桐屿街道","331004006":"峰江街道","331004103":"新桥镇","331004104":"横街镇","331004106":"金清镇","331004107":"蓬街镇","331004400":"滨海工业城","331004401":"滨海新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331004.json
// module id = 1121
// module chunks = 0